module.exports = data => {
  let min = Infinity
  let max = -Infinity
  data.forEach(value => {
    min = Math.min(min, value)
    max = Math.max(max, value)
  })
  return { min: min === Infinity ? 0 : min, max: max === -Infinity ? 0 : max }
}
